import {
  CatalogSectionKit,
  CatalogSectionProductColorV2,
} from '../../../../../modules/catalogs/products/interfaces/catalogProductList.types';
import { ESProduct } from '../../../../../modules/products/product.types.v2';
import { MediaType } from '../../../../../types/general.types';
import { uniqueColorImageUrl } from '../../../../../utils/image.constants';
import { SaleItemType } from '../../../../Search/interfaces/product-action.dto';
import { ItemToProductCard } from '../types/productCard.types';

interface ElasticProductColor extends ESProduct {
  type: SaleItemType.ELASTIC_PRODUCT_COLOR;
}

export const transformCatalogSectionItemToProductCard = (
  item: ElasticProductColor | CatalogSectionProductColorV2 | CatalogSectionKit,
): ItemToProductCard => {
  switch (item.type) {
    case SaleItemType.PRODUCT_COLOR: {
      return {
        name: item.name,
        code: item.code,
        referenceCode: item.referenceCode,
        allColors: item.allColors,
        selectedColor: item.allColors.find((color) => color.productColorId === item.productColorId),
        prices: item.prices,
        entityRelations: {
          type: SaleItemType.PRODUCT_COLOR,
          productId: item.productId,
          productColorId: item.productColorId,
        },
        availableForSale: item.availability && item.availability.length > 0,
        medias: item.medias,
        customTags: [...item.tags, ...item.colorClassifications],
      };
    }

    case SaleItemType.KIT: {
      const kitColor = {
        id: item.kitId,
        name: 'única',
        imageUrl: uniqueColorImageUrl,
        hexcode: '',
        isImage: true,
        productColorId: item.kitId,
      };

      return {
        name: item.kitName,
        code: item.kitCode,
        allColors: [kitColor],
        selectedColor: kitColor,
        availableForSale: item.kitAvailableForSale,
        referenceCode: item.kitCode,
        customTags: [],
        prices: [
          {
            wholesalePrice: item.kitWholesalePrice ?? 0,
          },
        ],
        entityRelations: {
          type: SaleItemType.KIT,
          kitId: item.kitId,
        },
        medias: item.kitImageUrl
          ? [
              {
                position: 0,
                url: item.kitImageUrl,
                type: MediaType.IMAGE,
              },
            ]
          : [],
      };
    }

    case SaleItemType.ELASTIC_PRODUCT_COLOR: {
      return {
        name: item.name,
        code: item.code,
        referenceCode: item.referenceCode,
        allColors: item.allColors,
        selectedColor: item.allColors.find((color) => color.productColorId === item.productColorId),
        prices: item.prices,
        medias: item.medias,
        customTags: [...item.tags, ...item.colorClassifications],
        availableForSale: item.availability && item.availability.length > 0,
        entityRelations: {
          type: SaleItemType.PRODUCT_COLOR,
          productId: item.productId,
          productColorId: item.productColorId,
        },
      };
    }
  }
};
